import { Action } from "@ngrx/store";
import { User } from "../../model/UserModel";
import { Organization } from "../../model/OrganizationModel";
import { Contributor } from "../../model/ContributorModel";
import { UserActionTypes } from ".";

export class LoginAction implements Action {
  public type = UserActionTypes.USER_LOGIN;
  public user: User;
  public contributor: Contributor;
  public organization: Organization;
  public token: string;
  public errorPayload: any;
  constructor(public payload: { user: any }) { }
}

export class ResetPasswordRequestAction implements Action {
  public type = UserActionTypes.USER_RESET_PASSWORD_REQUEST;
  public user: User;
  public contributor: Contributor;
  public organization: Organization;
  public token: string;
  public errorPayload: any;
  constructor() { }
}

export class ResetPasswordAction implements Action {
  public type = UserActionTypes.USER_RESET_PASSWORD;
  public user: User;
  public contributor: Contributor;
  public organization: Organization;
  public token: string;
  public errorPayload: any;
  constructor(public payload: { email: string, clientId: number }) { }
}

export class LoginKeyAction implements Action {
  public type = UserActionTypes.USER_LOGIN_KEY;
  public user: User;
  public contributor: Contributor;
  public organization: Organization;
  public token: string;
  public errorPayload: any;
  constructor(public payload: { key: string }) { }
}

export class LoginSuccessAction implements Action {
  public type = UserActionTypes.USER_LOGIN_SUCCESS;
  public user: User;
  public contributor: Contributor;
  public organization: Organization;
  public token: string;
  public errorPayload: any;
  constructor() { }
}

export class LogoutAction implements Action {
  public type = UserActionTypes.USER_LOGOUT;
  public user: User;
  public contributor: Contributor;
  public organization: Organization;
  public token: string;
  public errorPayload: any;
  constructor(public payload: any = null) { }
}

export type UserActions =  LoginAction | LoginKeyAction | LogoutAction | ResetPasswordAction ;



// WEBPACK FOOTER //
// ./src/store/action/UserActions.ts